import H1 from "../../../Atoms/H1";
import { useTranslation } from "react-i18next";
import Select from "../../../Atoms/Select";
import H2 from "../../../Atoms/H2";
import Input from "../../../Atoms/Input";
import { useState } from "react";
import dayjs from "dayjs";
import { useEffect } from "react";

const Step2 = (props) => {

    const { i18n } = useTranslation('common');

    const defaultValues = props.defaultValues || {};

    // function setOnline(e) {
    //     console.log(e.target.checked)
    // }
    // console.log("props.userLoggedIn")
    // console.log(props.userLoggedIn)

    // useEffect(() => {
    //     console.log("Current URL:", window.location.href);
    //     console.log("Contains 'joinb':", window.location.href.includes("joinb"));
    // }, []); // Empty dependency array to run this effect only once


    return (<>
        <H1>{i18n.language === "fr" ? "Participants" : "Participants"}</H1>
        <div className="flexblock">
            <div className='checkboxlist' >
                <span>{i18n.language === "fr" ? "Je souhaite participer" : "I wish to participate"}*</span><br/><br/>
                <label>
                    <input required type="radio" name="presentiel" value="oui" defaultChecked={defaultValues.presentiel === "oui"} />
                    {i18n.language === "fr" ? "En présentiel le mardi 4 juin 2024" : "In person on Tuesday, June 4, 2024"}
                </label>
                <label>
                    <input required type="radio" name="presentiel" value="non" defaultChecked={defaultValues.presentiel === "non"} />
                    {i18n.language === "fr" ? "En ligne le vendredi 7 juin 2024" : "Online on Friday, June 7, 2024"}
                </label>
                {(window.location.href.includes("joinb") || props.pop === "b") && (
                    <label>
                        <input required type="radio" name="presentiel" value="les_deux" defaultChecked={defaultValues.presentiel === "les_deux"} />
                        {i18n.language === "fr" ? "En présentiel le mardi 4 juin et en ligne le vendredi 7 juin 2024" : "In person on Tuesday, June 4 and online on Friday, June 7, 2024"}
                    </label>
                )}
                {/* <label>
                    <input required type="radio" name="presentiel" value="non" defaultChecked={defaultValues.presentiel === "non"} />
                    {i18n.language === "fr" ? "En présentiel le mardi 4 juin et en ligne le vendredi 7 juin 2024" : "In person on Tuesday, June 4 and online on Friday, June 7, 2024"}
                </label> */}
                {/* <label>
                    <input required type="radio" name="presentiel" value="les_deux" defaultChecked={defaultValues.presentiel === "les_deux"} />
                    {i18n.language === "fr" ? "En présentiel le mardi 4 juin 2024 et en ligne le vendredi 7 juin 2024" : "In person on Tuesday, June 4, 2024 and online on Friday, June 7, 2024"}
                </label> */}
            </div>
        </div><br />
        <div className="flexblock">
            <div style={{ minWidth: 'min(400px,100%)' }}>
                <H2>{i18n.language === "fr" ? "Participant 1" : "Participant 1"}</H2>
                <div className="flexblock">
                    <Input name="name1" style={{ width: "100%" }} required placeholder={i18n.language === "fr" ? "Nom" : "Name"} defaultValue={defaultValues.name1} />
                    <Input name="firstname1" style={{ width: "100%" }} required placeholder={i18n.language === "fr" ? "Prénom" : "First name"} defaultValue={defaultValues.firstname1} />
                </div><br />
                <div className="flexblock">
                    <Input name="email1" style={{ width: "100%" }} required placeholder={i18n.language === "fr" ? "Email" : "Email"} defaultValue={defaultValues.email1} />
                    <Input name="mobilephone1" style={{ width: "100%" }} required placeholder={i18n.language === "fr" ? "Téléphone mobile" : "Mobile phone"} defaultValue={defaultValues.mobilephone1} />
                </div><br />
                <div className="flexblock">
                    <Input name="landline1" style={{ width: "100%" }} required placeholder={i18n.language === "fr" ? "Téléphone fixe" : "Landline"} defaultValue={defaultValues.landline1} />
                    <Input name="jobtitle1" style={{ width: "100%" }} required placeholder={i18n.language === "fr" ? "Intitulé du poste" : "Job title"} defaultValue={defaultValues.jobtitle1} />
                </div><br />
            </div>
            <div style={{ minWidth: 'min(400px,100%)' }}>
                <H2>{i18n.language === "fr" ? "Participant 2 (obligatoire) soit second participant, soit remplaçant en cas d'empêchement" : "Participant 2 (compulsory) is either the second participant or a substitute if unable to attend"}</H2>
                <div className="flexblock">
                    <Input name="name2" style={{ width: "100%" }} required placeholder={i18n.language === "fr" ? "Nom" : "Name"} defaultValue={defaultValues.name2} />
                    <Input name="firstname2" style={{ width: "100%" }} required placeholder={i18n.language === "fr" ? "Prénom" : "First name"} defaultValue={defaultValues.firstname2} />
                </div><br />
                <div className="flexblock">
                    <Input name="email2" style={{ width: "100%" }} required placeholder={i18n.language === "fr" ? "Email" : "Email"} defaultValue={defaultValues.email2} />
                    <Input name="mobilephone2" style={{ width: "100%" }} required placeholder={i18n.language === "fr" ? "Téléphone mobile" : "Mobile phone"} defaultValue={defaultValues.mobilephone2} />
                </div><br />
                <div className="flexblock">
                    <Input name="landline2" style={{ width: "100%" }} required placeholder={i18n.language === "fr" ? "Téléphone fixe" : "Landline"} defaultValue={defaultValues.landline2} />
                    <Input name="jobtitle2" style={{ width: "100%" }} required placeholder={i18n.language === "fr" ? "Intitulé du poste" : "Job title"} defaultValue={defaultValues.jobtitle2} />
                </div><br />


            </div>


        </div>

        <span style={{ display: 'flex', marginTop: '40px', marginBottom: '40px' }}><input required style={{ marginRight: '20px' }} type="checkbox" name="consent" defaultChecked={defaultValues.consent} /><p style={{ fontSize: '16px' }}>{i18n.language === "fr" ? "Je m'engage à prévenir en cas d'empêchement ou de changement d'intervenant l'équipe du Le FRENCH DESIGN by VIA, deux semaines avant la date de l'évènement.*" : "I agree to inform the Le FRENCH DESIGN team 2 weeks before the date of the event if I am unable to attend or if there is a change of speaker."}</p></span>
    </>);
}

export default Step2;